import type { CityConfig } from "../city-template/types";

export const skokieConfig: CityConfig = {
  city: "Skokie",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "skokie",
  route: "/skokie",
  title: "Emergency Passport Skokie, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Skokie, Illinois — as fast as 24 hours. Fast passport renewal and new passport applications for Skokie, Lincolnwood, Niles, and all North Shore Cook County residents. A+ BBB rated registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Skokie, IL",
  heroSubtitle: "North Shore family vacation to Israel with a week's notice? Skokie business trip to Tel Aviv and your passport expired? Lincolnwood resident heading to Europe for summer travel? We help Skokie and North Shore Cook County residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Skokie%20Illinois%20suburban%20cityscape%20with%20Westfield%20Old%20Orchard%20outdoor%20shopping%20mall%2C%20Illinois%20Holocaust%20Museum%20modern%20architecture%2C%20tree-lined%20residential%20streets%20with%20mid-century%20homes%20and%20lawns%2C%20North%20Shore%20Sculpture%20Park%20art%20installations%2C%20bright%20sunny%20autumn%20day%20with%20golden%20foliage%2C%20professional%20suburban%20landscape%20photography%2C%20vibrant%20diverse%20community%20atmosphere&width=1800&height=700&seq=skokie-hero-001&orientation=landscape",
  heroImageAlt: "Skokie Illinois North Shore suburb with Old Orchard Mall and tree-lined neighborhoods",
  geoPosition: "42.0324;-87.7416",
  geoPlacename: "Skokie, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 30 minutes south of Skokie via I-94 or Edens Expressway",
  },
  nearbyCitiesZips: [
    { name: "Skokie", zips: "60076, 60077" },
    { name: "Lincolnwood", zips: "60712" },
    { name: "Niles", zips: "60714" },
    { name: "Morton Grove", zips: "60053" },
    { name: "Evanston", zips: "60201, 60202, 60203" },
    { name: "Wilmette", zips: "60091" },
    { name: "Glenview", zips: "60025, 60026" },
    { name: "Northbrook", zips: "60062" },
    { name: "Winnetka", zips: "60093" },
    { name: "Glencoe", zips: "60022" },
    { name: "Park Ridge", zips: "60068" },
    { name: "Des Plaines", zips: "60016, 60018" },
    { name: "Highland Park", zips: "60035" },
    { name: "Deerfield", zips: "60015" },
    { name: "Northfield", zips: "60093" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 30 minutes away but you skip the trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "International Community Hub", desc: "Serving Skokie's globally connected families with visa and passport expertise" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no downtown Chicago trip required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Evanston, IL", route: "/evanston" },
    { name: "Emergency passport help in Chicago, IL", route: "/chicago" },
    { name: "Urgent passport services in Lincolnwood, IL", route: "/illinois" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Skokie, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (30 minutes south via the Edens Expressway) — without you making the trip. Skokie residents can ship from any UPS or FedEx on the North Shore.",
  fpcOfficeDistance: "Serving Skokie, Lincolnwood, Niles, Morton Grove, Evanston, Wilmette, Glenview, Northbrook, Winnetka, Glencoe, Park Ridge, and all of the North Shore",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Skokie and Chicago's North Shore. From the Westfield Old Orchard shopping district and the Illinois Holocaust Museum campus to the residential neighborhoods of Lincolnwood and the corporate corridors along the Edens Expressway, from the diverse international community of central Skokie to the tree-lined streets of Morton Grove — we serve all of the North Shore and beyond.",
  nearbyCitiesIntro: "We serve Skokie and all nearby communities including Lincolnwood, Niles, Morton Grove, Evanston, Wilmette, Glenview, Northbrook, Winnetka, Glencoe, Park Ridge, Des Plaines, Highland Park, Deerfield, and Northfield. We also serve all North Shore communities and northern Cook County.",
  howItWorksIntro: "Most Skokie travelers complete everything online and ship documents overnight. No need to drive 30 minutes to downtown Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Skokie is one of the North Shore's largest and most internationally diverse communities with strong family ties around the world. Here are the most common passport mistakes we see from Skokie and North Shore travelers.",
  testimonialsIntro: "Skokie and North Shore travelers — from globally-connected families to corporate professionals to retirees exploring the world — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Skokie, IL? Here are the most common ones we hear from North Shore Cook County travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No drive to downtown Chicago required", "Perfect for international family visits and business travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 30 minutes to downtown Chicago", "Downtown Chicago parking and navigation"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Skokie travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 30 minutes away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "North Shore family and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Skokie adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Skokie address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Skokie residents — including families with young children, new citizens, and international community members.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Skokie residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Skokie families with kids traveling to visit relatives internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Skokie and Cook County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Skokie IL", description: "Urgent passport processing for Skokie Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Skokie IL", description: "Fast passport renewal for Skokie Illinois residents with a previously-issued passport." },
    { name: "First-Time Passport Skokie IL", description: "New passport application services for Skokie Illinois residents applying for their first passport." },
    { name: "Child Passport Skokie IL", description: "Minor passport services for Skokie Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "David K.",
      location: "Skokie, IL",
      rating: 5,
      text: "Family trip to Israel for my daughter's bat mitzvah and my passport had expired. Fast Passport Center got my renewal in 38 hours. Shipped from the UPS on Touhy Avenue. The dedicated agent understood the urgency — I didn't even miss a day of work.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Rachel S.",
      location: "Lincolnwood, IL",
      rating: 5,
      text: "Three passports for a family reunion in London — two adult renewals and one first-time child passport. Fast Passport Center got all three done in 4 days. We shipped from FedEx on Lincoln Avenue. Incredible, stress-free service for North Shore families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Samir P.",
      location: "Skokie, IL",
      rating: 5,
      text: "Last-minute business trip to Mumbai with 6 days notice. Fast Passport Center processed my passport renewal in 2 days. I used the UPS near Old Orchard. Amazing that I didn't have to drive downtown — saved me hours for trip prep.",
      service: "Expedited Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "skk-1",
      name: "Skokie Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4950 Madison St",
      city: "Skokie",
      state: "IL",
      zip: "60077",
      phone: "(847) 676-0070",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Skokie, near Madison Street corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Skokie acceptance facility. Appointments required — book 1–2 weeks in advance. Near Old Orchard shopping area.",
      icon: "ri-mail-line",
    },
    {
      id: "skk-2",
      name: "Cook County Clerk — Skokie",
      type: "County Clerk Passport Acceptance",
      address: "5600 Old Orchard Rd, Room 149",
      city: "Skokie",
      state: "IL",
      zip: "60077",
      phone: "(312) 603-5656",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Skokie, Cook County Satellite Office near Old Orchard Mall",
      website: "https://www.cookcountyclerk.com/",
      websiteLabel: "Cook County Clerk",
      notes: "Cook County Clerk satellite passport acceptance. Serves North Shore communities. Call ahead to confirm hours.",
      icon: "ri-government-line",
    },
    {
      id: "skk-3",
      name: "Lincolnwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3900 W Devon Ave",
      city: "Lincolnwood",
      state: "IL",
      zip: "60712",
      phone: "(847) 679-1992",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lincolnwood, approximately 3 miles south of Skokie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lincolnwood and southern Skokie residents. Convenient to Devon Avenue corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "skk-4",
      name: "Niles Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6935 W Touhy Ave",
      city: "Niles",
      state: "IL",
      zip: "60714",
      phone: "(847) 647-4530",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Niles, approximately 3 miles west of Skokie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Niles, Morton Grove, and western Skokie residents. Full passport acceptance services.",
      icon: "ri-mail-line",
    },
    {
      id: "skk-5",
      name: "Morton Grove Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9114 Waukegan Rd",
      city: "Morton Grove",
      state: "IL",
      zip: "60053",
      phone: "(847) 965-5411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Morton Grove, approximately 4 miles northwest of Skokie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Morton Grove and northwest Skokie residents. Good alternative facility.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30 min drive to downtown Chicago", fpc: "No — ship from Skokie" },
    { feature: "Parking & Navigation", agency: "Downtown Chicago parking costs", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Holiday Travel Rush",
      description: "Skokie families traveling for Jewish holidays, summer reunions, and school breaks often discover expired documents weeks before departure. Routine processing takes 6–13 weeks — start expedited at least 6 weeks ahead.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Photo services around Old Orchard and Touhy Avenue sometimes produce photos that don't meet strict State Department standards. Photos must be exactly 2x2 inches, white background, no shadows.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Forms",
      description: "Missing signatures or incorrect form types are the #1 rejection reasons at Skokie and Niles acceptance facilities. Double-check that you're using the correct form (DS-11 vs DS-82) before your appointment.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Both Parents for Minors",
      description: "For child passports, both parents must appear at the acceptance facility or submit notarized consent. Skokie families often arrive with only one parent, causing rejected applications.",
    },
    {
      icon: "ri-global-line",
      title: "International Travel Document Mix-Ups",
      description: "Skokie's diverse international community sometimes confuses passport renewal with foreign citizenship documentation. Your U.S. passport is separate from any other country's documentation.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Skokie travelers often assume the 30-minute proximity to the Chicago Passport Agency means they can handle things last-minute. Agency appointments fill 2–3 weeks out — use a courier service instead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Skokie or the North Shore." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Old Orchard Mall or Touhy Avenue." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — experienced with family travel, visa requirements, and international documentation." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 30 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Skokie address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Skokie, IL?", a: "Fast Passport Center offers emergency passport processing in Skokie, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (30 minutes south via the Edens Expressway) — without you making the trip." },
    { q: "Does Skokie have its own passport agency?", a: "No — Skokie does not have a regional passport agency. The nearest facility is the Chicago Passport Agency (approximately 30 minutes south via I-94 Edens Expressway). Fast Passport Center's courier service means Skokie residents never need to make the trip." },
    { q: "Can I get an expedited passport in Lincolnwood or Niles?", a: "Absolutely. Fast Passport Center serves all of the North Shore including Lincolnwood, Niles, Morton Grove, Evanston, Wilmette, Glenview, and all northern Cook County communities. Our service works the same way everywhere." },
    { q: "What airport do Skokie travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is approximately 20 minutes west of Skokie via I-294. Chicago Midway (MDW) is approximately 40 minutes south. O'Hare offers the most extensive international connections for North Shore travelers." },
    { q: "Where can I get passport photos in Skokie?", a: "Walgreens and CVS locations throughout Skokie and Lincolnwood offer passport photos. FedEx Office at Old Orchard Mall and UPS Store on Touhy Avenue also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Can I get a passport for my child in Skokie?", a: "Yes. Fast Passport Center provides child passport services for minors under 16 throughout Skokie and the North Shore. Both parents or legal guardians must typically be present at the acceptance facility." },
    { q: "How far is the Chicago Passport Agency from Skokie?", a: "The Chicago Passport Agency is approximately 30 minutes south of Skokie via the Edens Expressway (I-94). However, you need an appointment booked 2–3 weeks in advance and it's only for life-or-death emergencies. Our courier service handles the trip for you." },
    { q: "Do you serve the Skokie international community?", a: "Yes. Fast Passport Center proudly serves Skokie's diverse international community. We understand the unique documentation needs of travelers visiting family abroad, dual citizens, and naturalized citizens applying for their first U.S. passport." },
  ],
  photoLocations: [
    { name: "Walgreens — Skokie", address: "9700 Skokie Blvd, Skokie, IL 60077", hours: "Mon–Sun: 7AM–10PM" },
    { name: "FedEx Office — Old Orchard", address: "4925 Old Orchard Center, Skokie, IL 60077", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS — Skokie", address: "4800 Oakton St, Skokie, IL 60077", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Lincolnwood", address: "3950 W Devon Ave, Lincolnwood, IL 60712", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Niles", address: "8920 N Greenwood Ave, Niles, IL 60714", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Closest to Skokie — approximately 3 miles west. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Evanston", address: "1840 Oak Ave, Evanston, IL 60201", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Evanston, Skokie, and northeast Cook County. Full REAL ID processing available. Online reservations recommended.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Cook County birth and death certificates" },
    { label: "Marriage Licenses (Cook County Clerk)", url: "https://www.cookcountyclerk.com/service/marriage-licenses", desc: "Cook County Clerk — marriage license applications and certified copies for Skokie and North Shore" },
    { label: "Divorce Decrees (Cook County Circuit Clerk)", url: "https://www.cookcountyclerkofcourt.org/", desc: "Cook County Circuit Clerk — divorce decree records for Skokie and Cook County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 20 minutes west via I-294",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Skokie and the North Shore. One of the world's busiest airports with direct flights worldwide. Convenient via Dempster Street and I-294.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 40 minutes south via I-94 and I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub. Good for domestic connections and Southwest international routes to Mexico and the Caribbean.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};